module.exports = __webpack_public_path__ + "img/undraw_diet.5686c319.svg";